export const GET_PROPERTY_INIT = "GET_PROPERTY_INIT";
export const GET_PROPERTY_SUCCESS = "GET_PROPERTY_SUCCESS";
export const GET_PROPERTY_ERROR = "GET_PROPERTY_ERROR";

export const POST_PROPERTY_UPDATE_INIT = "POST_PROPERTY_UPDATE_INIT";
export const POST_PROPERTY_UPDATE_SUCCESS = "POST_PROPERTY_UPDATE_SUCCESS";
export const POST_PROPERTY_UPDATE_ERROR = "POST_PROPERTY_UPDATE_ERROR";